import { getJWTLocalStorage } from '@/utils/local-storage/user/local-storage';
import axios, { AxiosRequestConfig } from 'axios';
const URL_API = import.meta.env.VITE_URL_API;

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'OPTIONS';

const processValue = (key: string, value: unknown) => {
	if (key === 'user_main_key') {
		return String(value).toUpperCase();
	}

	if (typeof value === 'boolean') {
		return value;
	}
	return (!isNaN(Number(value)) && value !== '' && !/^0x/i.test(String(value))) ? Number(value) : value;
};

export const fetchPersea = async (
	path_url: string,
	method: HttpMethod = 'GET',
	params = {},
	body = {},
	JWTTemp: string | null = null
) => {

	const processedParams = Object.entries(params).reduce((acc, [key, value]) => ({
		...acc,
		[key]: processValue(key, value)
	}), {});

	const processedBody = Object.entries(body).reduce((acc, [key, value]) => ({
		...acc,
		[key]: processValue(key, value)
	}), {});

	const JWT = JWTTemp ?? getJWTLocalStorage() ?? import.meta.env.VITE_X_API_KEY;
	const defaultConfig: AxiosRequestConfig = {
		method: method,
		url: `${URL_API}/${path_url}`,
		headers: {
			'Content-Type': 'application/json',
			'X-API-KEY': `${JWT}`,
		},
	};

	if (method === 'GET') {
		defaultConfig.params = processedParams;
	} else {
		defaultConfig.data = {
			params: {
				...processedParams,
			},
		};
	}

	if (params) {
		defaultConfig.params = processedParams;
	}

	if (method !== 'GET' && processedBody) {	
		defaultConfig.data = processedBody;
	}

	const response = await axios(defaultConfig);
	return response?.data ?? null;
};